import React from 'react';
import { motion } from 'framer-motion';
import { PhoneCall, ClipboardCheck, Wrench, Droplets } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const STEPS = [{
  icon: PhoneCall,
  title: 'Request a Quote',
  desc: 'Call or message us. We learn about your home and water goals.'
}, {
  icon: ClipboardCheck,
  title: 'Free Water Test',
  desc: 'We test your water and recommend the right system for Tulsa conditions.'
}, {
  icon: Wrench,
  title: 'Pro Installation',
  desc: 'Our certified techs install your system — cleanly and on schedule.'
}, {
  icon: Droplets,
  title: 'Enjoy Clean Water',
  desc: 'Softer skin, spotless dishes, and crisp water from every tap.'
}];
export function HowItWorks() {
  return <section id="how" className="relative overflow-hidden bg-navy-900 py-20 sm:py-24" data-id="element-98" data-mp="os0mm4wq8bm2">
      <div className="pointer-events-none absolute right-0 top-0 h-72 w-72 rounded-full bg-brand-blue/15 blur-[110px]" data-id="element-99" data-mp="34jfz9ndafwjn" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6" data-id="element-100" data-mp="39l5b358c4e8s">
        <SectionHeading dark eyebrow="How It Works" title={<span className="text-white" data-id="element-102" data-mp="kf6fzl4bven">From tap to pure in four simple steps</span>} subtitle="No pressure, no gimmicks — just honest advice and a system tailored to your home." data-id="element-101" data-mp="5igpwlmghwqn" />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-103" data-mp="aimiq54gppab">
          {STEPS.map((s, i) => <motion.div key={s.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur" data-id="element-104" data-mp="ohm7dcrz646h" data-mpi={i}>
              <span className="absolute right-5 top-5 font-heading text-4xl font-extrabold text-white/10" data-id="element-105" data-mp="178lt8546axvj">
                {i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-cyan text-white" data-id="element-106" data-mp="138bk4jl33rcg">
                <s.icon className="h-6 w-6" data-id="element-107" data-mp="1ac1od050lg44" />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-white" data-id="element-108" data-mp="1f8i8zkd09ccg">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/70" data-id="element-109" data-mp="1k84pc2o4r8ph">{s.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}